import React from 'react';
import Svg from '../Svg';

interface IAddLocation {
  fill?: string;
  stroke?: string;
  color?: string;
  size?: string;
}

const Replace: React.FC<IAddLocation> = ({ fill = 'none', stroke = '#0B1215', color, size = '16px' }) => (
  <Svg fill={fill} color={color} size={size} path="" viewBox="0 0 14 14">
    <g clipPath="url(#clip0_1015_1550)">
      <path d="M9.91699 0.585938L12.2503 2.91927L9.91699 5.2526" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.75 6.41406V5.2474C1.75 4.62856 1.99583 4.03506 2.43342 3.59748C2.871 3.1599 3.46449 2.91406 4.08333 2.91406H12.25" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.08333 13.4167L1.75 11.0833L4.08333 8.75" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.25 7.58594V8.7526C12.25 9.37144 12.0042 9.96493 11.5666 10.4025C11.129 10.8401 10.5355 11.0859 9.91667 11.0859H1.75" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1015_1550">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export default Replace;
